import React, { useCallback, useMemo } from 'react'
import { formatNumberBR } from 'src/utils'
import { SalesReceivementBatch } from 'src/features/receivement/ReceivementTypes'
import { useSelector } from 'src/utils/store'
import * as S from '../styles'

interface Props {
  batch: SalesReceivementBatch
}

export const ReturnQuantityInput = React.memo(({ batch }: Props) => {
  const batchState = useSelector(
    (state) => state.receivement.batchesStateByBatchItemOrderIds[batch.idsBatchItemOrder.join(',')],
  )

  const formatInputNumber = useCallback(
    (returnQuantity) => {
      if (typeof returnQuantity !== 'number') {
        return ''
      }

      if (batch.measureUnit.isKg) {
        return formatNumberBR(returnQuantity, 3)
      }

      return formatNumberBR(returnQuantity)
    },
    [batch.measureUnit.isKg],
  )

  const returnQuantityFormatted = useMemo(
    () => formatInputNumber(batchState.returnQuantity || 0),
    [batchState.returnQuantity, formatInputNumber],
  )

  return (
    <S.QuantityWrapper>
      <S.Input
        aria-label='Quantidade a ser devolvida do lote'
        data-testid='return-quantity-input'
        value={returnQuantityFormatted}
        readOnly
      />
    </S.QuantityWrapper>
  )
})
